import { LayoutMapConfigModel } from '../_model/layout-map-config.model';

export class LayoutMapConfig{
    public default: LayoutMapConfigModel = {
        listDevice:{
            baseData:{
                icon:true,
                duration:true,
                speed:true,
                battery:true,
                gsm:true
            },
            deviceData:{
                numberPlate:true,
                imei:true,
                simno:false,
                vin:false,
                powerVoltage:false,
                distanceToday:true,
                driver:false,
                drivingToday:true,
                updateTime:true,
                group:false,
                geofence:false,
                address:true,
            }
        },
        listDeviceBase:{
            baseData:{
                icon:true,
                duration:true,
                speed:true,
                battery:true,
                gsm:true
            },
            deviceData:{
                numberPlate:true,
                imei:true,
                simno:true,
                vin:false,
                powerVoltage:true,
                distanceToday:true,
                driver:true,
                drivingToday:true,
                updateTime:true,
                group:false,
                geofence:false,
                address:true,
            }
        },
        infoDeviceMulti:{
            baseData:{
                isShow:true,
                showFull:false,
            },
            deviceData:{
                numberPlate:true,
                imei:false,
                simno:false,
                vin:false,
                gsm:true,
                duration:true,
                battery:false,
                powerVoltage:false,
                distanceToday:true,
                driver:false,
                drivingToday:true,
                updateTime:true,
                group:false,
                geofence:false,
                address:true,
            }
        },
        infoDevice:{
            baseData:{
                icon:true,
                duration:true,
                speed:true,
                battery:true,
                gsm:true,
            },
            deviceData:{
                numberPlate:true,
                imei:true,
                simno:true,
                vin:true,
                powerVoltage:true,
                distanceToday:true,
                driver:true,
                drivingToday:true,
                updateTime:true,
                group:true,
                geofence:true,
                address:true,
            },
            lastDay:{
                distance:true,
                driving:true,
                stop:true,
            },
            other:{
                air:true,
                door:true,
                engine:true,
                ben:true,
            }
        },
        tracking:{
            info:{
                baseData:{
                    icon:true,
                    duration:true,
                    speed:true,
                    battery:true,
                    gsm:true,
                },
                deviceData:{
                    numberPlate:true,
                    imei:true,
                    simno:true,
                    vin:true,
                    powerVoltage:true,
                    distanceToday:true,
                    driver:true,
                    drivingToday:true,
                    updateTime:true,
                    group:true,
                    geofence:true,
                    address:true,
                },
                lastDay:{
                    distance:true,
                    driving:true,
                    stop:true,
                },
                other:{
                    air:true,
                    door:true,
                    engine:true,
                    ben:true,
                }
            },
            route:{
                summary:{
                    distance:true,
                    driving:true,
                    stop:true,
                }
            },
            chart:{
    
            }
        },
        

    }
}